import React, { useContext, useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { Box, CircularProgress } from '@mui/material';

import { db } from '../../firebaseConfig/firebase.config';
import { updateAction } from '../action/updateAction';
import { useCustomParam } from '../../hooks/use-custom-param';
import { RecordContext } from '../record-context';
import { DraggableSteps } from '../drageble-steps';
import { Step } from '../step';
import { Header } from '../header';
import { Hero } from '../hero';
import { NoPage } from '../no-page';

import { useStyles } from './styles';
import { detectURLs } from '../../utils';
import {NoSteps} from "../no-steps";

export const Record = () => {
  const { id } = useParams();
  const {record, recordDispatch} = useContext(RecordContext);
  const [links, setLinks] = useState([]);
  const isEdit = false;
  const classes = useStyles();

  // useEffect(() => {
  //   if (!record.arr.length) {
  //     onSnapshot(collection(db, 'records'), (snapshot) => {
  //       snapshot.docs.forEach((doc) => {
  //         if (doc.id === id)
  //           recordDispatch(updateAction({
  //             ...doc.data(),
  //             isLoaded: true
  //         }));
  //       })
  //     })
  //   }
  // } )

  useEffect(async () => {
    if (!record.arr.length && !record.isLoaded) {
      const docRef = doc(db, "records", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
          recordDispatch(updateAction({
            ...docSnap.data(),
            isLoaded: true,
            noSuchDocument: false,
            needSave: false
        }));
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!", docSnap);
        recordDispatch(updateAction({
          isLoaded: true,
          noSuchDocument: true
        }));
      }
    }
  })

  useEffect(() => {
    if (record.arr.length) {
      let arr = [];
      record.arr.forEach(step => {
        const stepLinks = detectURLs(step.name);
        if (stepLinks) {
          arr = [].concat(arr, stepLinks)
        }
      });
      setLinks(arr);
    }
  }, [record.arr])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (record.needSave) {
        recordDispatch(
          updateAction({
            ...record,
            saving: true
          })
        );
        setDoc(doc(db, 'records', id), { ...record }).then(() =>
        {
          recordDispatch(
            updateAction({
              ...record,
              needSave: false,
              saving: false
            })
          );
        });
      }
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [record]);

  return (
    <Box className={classes.root}>
      <Header/>
      {!record.isLoaded &&
          <Box display="flex" justifyContent="center" alignItems="center" sx={{height: 'calc(100vh - 80px)'}}>
            <CircularProgress/>
          </Box>
      }
      { (record.isLoaded && record.noSuchDocument) && <NoPage /> }
      { (record.isLoaded && !record.noSuchDocument) &&
          <Box pb={6}>
            <Box className={classes.content}>
              <Hero links={links}/>
              <Container>
                {isEdit ?
                    <DraggableSteps/>
                    : record.arr.length ? record.arr.map((step, index) =>
                            <Box sx={{maxWidth: 800, margin: '0 auto'}}>
                              <Step index={index} step={step}/>
                            </Box>)
                        : <NoSteps />
                }
              </Container>
            </Box>
          </Box>
      }
    </Box>
  )
}